export const endpoints = {
  auth: {
    login: '/v1/auth/login',
    googleLogin: '/v1/auth/google-login',
    logout: '/v1/auth/logout',
    refreshTokens: '/v1/auth/refresh-tokens',
    forgotPassword: '/v1/auth/forgot-password',
    resetPassword: '/v1/auth/reset-password',
    tassoQuintoToken: '/v1/auth/tasso-quinto-token',
  },
  user: {
    getAllUsers: '/v1/users/all',
    createUser: '/v1/users',
    editUser: '/v1/users',
    deleteUser: '/v1/users',
  },
  googleCalendar: {
    auth: '/v1/google-calendar/auth',
    status: '/v1/google-calendar/status',
    disconnect: '/v1/google-calendar/disconnect',
    events: '/v1/google-calendar/events',
  },
};
